import React from 'react';
import PropTypes from 'prop-types';
import { PrintSize } from '../../../prop-types';
import PandaViewSimplePreviews from '../../../common/panda-view-simple-previews';
import EditablePhotoButtons from './editable-photo-buttons';

const EditablePhoto = props => {
  const { photo, isLastPhoto, onAdvancedEdit, recommendedPrintSize } = props;

  return (
    <div className="d-flex">
      <div className="editable-photo-wrapper flex-shrink-0">
        <PandaViewSimplePreviews
          {...photo}
          isWallet={photo.size.title === 'Wallet'}
          size_area={photo.size.area}
          recommendedPrintSize={recommendedPrintSize}
          showSize={false}
          showQuantity={false}
          showLowQualityWarning
          lowQualityInformationPosition="bottom"
          lowQualityInformationCSSClasses="mobile"
        />
        <EditablePhotoButtons
          photo={photo}
          isLastPhoto={isLastPhoto}
          onAdvancedEdit={onAdvancedEdit}
        />
      </div>
    </div>
  );
};

EditablePhoto.propTypes = {
  photo: PrintSize,
  isLastPhoto: PropTypes.bool,
  availableSizes: PropTypes.arrayOf(PrintSize),
  sizesWithRootImage: PropTypes.arrayOf(PrintSize),
  onAdvancedEdit: PropTypes.func,
}.isRequired;

export default EditablePhoto;
